// @core/api/endpoints/bootstrap/get_status.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetBootstrapStatusResponse,
} from '../../../types/bootstrap';

const BASE_PATH = '/bootstrap';

/**
 * Get bootstrap status
 * Returns the current bootstrap status and wizard state. Used by the UI on initial load to determine what screen to show.
 * @public This endpoint does not require authentication
 */
export async function GetStatus(
  params?: {
  },
  options?: RequestOptions
): Promise<GetBootstrapStatusResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/setup/status`;
  const requestOptions = { ...options, skipAuth: true };
  return client.get<GetBootstrapStatusResponse>(requestPath, { ...requestOptions, params });
}
